import React, { useEffect, useState } from "react";
import { Button, Layout } from "components/index";
import AlertCardMain from 'pages/MainPage/components/AlertCard/AlertCardMain'
import NewsCard from "./components/NewsCard";
import { TextareaAutosize } from "@material-ui/core";
import userInfo from "utils/userInfo";
import AlertCard from "./components/AlertCard/AlertCard";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { PostNews } from "service/AlertService";
import { postNewNews } from "store/slices/AlertSlice";
import Notification from "utils/Notifications";
import { useDispatch } from "react-redux";
import { ScaleLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom'
import stylesB from "./MainPage.module.scss";
import stylesW from "./MainPageW.module.scss";
import Weather from "./components/WeatherCard/Weather";
import GoogleTranslate from './components/GoogleTranslate/GoogleTranslate';


function MainPage() {
  const [styles, setThem] = useState(stylesB)
  const user = userInfo();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [file, setFile] = useState([]);
  const [loader, setLoader] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [title_news, setTitle_news] = useState("");
  const [discrip, setDiscrip] = useState("");
  const [url_news, setUrl_news] = useState("");
  const [url_video, setUrl_video] = useState("");

  const [width, setWidth] = useState(window.innerWidth);
  const onFileChange = (event) => {
    setFile(event.target.files);
  };
  useEffect(() => {
    if (user?.them) {
      setThem(stylesW)
    }
    else {
      setThem(stylesB)
    }
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  useEffect(() => {
    width < 600 && handleSideNavToggle();
  });
  function handleSideNavToggle() {
    console.log("CHU")
  }
  const dispatch = useDispatch();
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (title_news === "") {
      setNotify({
        isOpen: true,
        message: " Вы не написали тему новости",
        type: "warning", sound: 'warning'
      });
    } else if (discrip === "") {
      setNotify({
        isOpen: true,
        message: " Вы не написали описание новости",
        type: "warning", sound: 'warning'
      });
    } else {
      try {
        setLoader(true);
        const formData = new FormData();
        formData.append('title', title_news);
        formData.append('description', discrip);
        formData.append('url_news', url_news);
        formData.append('url_video', url_video);

        for (let i = 0; i < file.length; i++) {
          formData.append('files', file[i]);
        }

        let response = await PostNews(formData);

        dispatch(
          postNewNews({
            title: title_news,
            description: discrip,
            file: file ? file.name : null,
            url_news: url_news,
            url_video: url_video,
          })
        );

        setNotify({
          isOpen: true,
          message: "Новость успешно опубликована",
          type: "success", sound: "success"
        });
        window.location.reload();
      } catch (error) {

        setNotify({
          isOpen: true,
          message: "Ошибка",
          type: "error",
        });
      } finally {
        setLoader(false);
      }

    }
  };
  const navigate = useNavigate()
  const Greeting = () => {
    const currentTime = new Date().getHours();

    const getRandomItem = (array) => {
      return array[Math.floor(Math.random() * array.length)];
    };

    const greetings = {
      morning: ['Доброе утро', 'Утречко', 'Рада вас видеть'],
      afternoon: ['Добрый день', 'Успешного дня', 'Приятного дня'],
      evening: ['Добрый вечер', 'Успешного вечера', 'Хорошего вечера'],
      night: ['Доброй ночи', 'Приятной ночи', 'Успешной ночи'],
    };

    let greeting = '';
    if (currentTime < 12 && currentTime > 5) {
      greeting = getRandomItem(greetings.morning);
    } else if (currentTime < 18 && currentTime > 11) {
      greeting = getRandomItem(greetings.afternoon);
    } else if (currentTime < 22 && currentTime > 17) {
      greeting = getRandomItem(greetings.evening);
    } else {
      greeting = getRandomItem(greetings.night);
    }

    return <div>{greeting}</div>;
  };
  return (
    <Layout>
      <div className={styles.main_wrapper}>
        <div className={styles.news_wrapper}>
          <div  className={styles.news_welcome_wrapper_div}>
            <div className={styles.news_welcome_wrapper}>
              <h2 style={{ color: "#333333", display: "flex", alignItems: "center" }}>{Greeting()}  <span style={{ color: "#736CED", marginLeft: "10px" }}> {user?.firstName}</span>!</h2>
              <GoogleTranslate />
        
              <AlertCardMain />
            </div>
            <div className={styles.news_welcome_wrapper}>
              <Weather />
            </div>
          </div>
          {width > 1080 ? (

            <div style={{ display: "flex", gap: "25px" }}>
              {/* <h1>Новости</h1>{" "} */}

              {user?.is_admin_of_news ? (
                <button
                  onClick={() => setOpenModal(true)}
                  className={styles.btn_create_news}
                >
                  Создать новость
                </button>
              ) : (
                ""
              )}{" "}
              {user?.is_admin_of ? (
                <button
                  onClick={() => navigate("/admin_organizations/")}
                  className={styles.btn_create_news}
                >
                  Администрация
                </button>
              ) : (
                ""
              )}{" "}
            </div>
          ) : (
            <h1>Оповещения</h1>
          )}
          {width > 1080 ? <NewsCard /> : <AlertCard />}
          {width < 1080 ? <><div style={{ display: "flex", gap: "25px", flexDirection: 'row' }}><h1>Новости</h1>{user?.is_admin_of_news ? (
            <button
              onClick={() => setOpenModal(true)}
              className={styles.btn_create_news}
            >
              Создать новость
            </button>

          ) : (
            ""
          )}{" "}</div></> : null}
          {width < 1080 ? <NewsCard /> : null}
        </div>
      </div>
      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={"Добавьте новость"}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <h4>Загаловок</h4>
          <input
            type="text"
            placeholder="Заголовок новости:"
            className={styles.type_input}
            value={title_news}
            onChange={(e) => setTitle_news(e.target.value)}
          />
          <h4>Описание</h4>
          <TextareaAutosize
            type="textarea"
            placeholder="Описание:"
            className={styles.discription_input}
            value={discrip}
            onChange={(e) => setDiscrip(e.target.value)}
          />
          <h4>Ссылки (укажите ссылки через пробел)</h4>
          <input
            type="text"
            placeholder="Ссылка:"
            className={styles.type_input}
            value={url_news}
            onChange={(e) => setUrl_news(e.target.value)}
          />
          <h4>Ссылка на YouTube</h4>
          <input
            type="text"
            placeholder="YouTube:"
            className={styles.type_input}
            value={url_video}
            onChange={(e) => setUrl_video(e.target.value)}
          />
          <h4>Файлы</h4>
          <div className={styles.add_statement_file}>
            <input type="file" multiple onChange={onFileChange} />
            <span>Прикрепление файла</span>
          </div>
          {loader ? (
            <ScaleLoader color="black" size={30} />
          ) : (
            <>

              <Button onClick={handleSubmit} className={styles.btn_send}>
                {" "}
                Отправить
              </Button>
              <Button
                onClick={() => setOpenModal(false)}
                className={styles.btn_pin_close}
              >
                {" "}
                Закрыть
              </Button>
            </>
          )}

        </div>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  );
}

export default MainPage;
